import {Button, FormHelperText, Grid} from '@material-ui/core';
import {useCallback, useContext} from 'react';
import {Link} from 'react-router-dom';
import {FormState} from 'components/forms/context';
import {useClearForm} from 'components/forms/hooks';

const requiresSignedPaperworkText =
    'The MM-SEAS system only accepts signed paperwork. You will not be able to submit an unsigned document. You will need to start again and upload a new photo once your document is signed.';

const AbortButton = () => {
    const {node} = useContext(FormState);
    const clearForm = useClearForm(node);

    const onAbortClick = useCallback(() => {
        clearForm();
    }, [clearForm]);

    return (
        <Button
            component={Link}
            to='/seaservice'
            variant='contained'
            color='secondary'
            onClick={onAbortClick}
        >
            Discard and Exit
        </Button>
    );
};

const RequiresSignatureAbortButton = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormHelperText error>
                    {requiresSignedPaperworkText}
                </FormHelperText>
            </Grid>
            <Grid item xs={12}>
                <AbortButton />
            </Grid>
        </Grid>
    );
};

export default RequiresSignatureAbortButton;
export {AbortButton, requiresSignedPaperworkText};
